import { useState, useCallback } from 'react';
import { getRandomAnnouncement } from './announcementTemplates';

const API_KEY = 'sk_b9ec77c6c792b5a629a93c3e305e2682061ca0909753f338';  // Replace with your key
const VOICE_ID = 'cgSgspJ2msm6clMCkdW9';

export const useElevenLabs = () => {
  const [isLoading, setIsLoading] = useState(false);

  const speak = useCallback(async (routine) => {
    if (!routine) return;
    
    setIsLoading(true);
    try {
      const announcement = getRandomAnnouncement(routine);
      
      const response = await fetch(`https://api.elevenlabs.io/v1/text-to-speech/${VOICE_ID}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'xi-api-key': API_KEY,
        },
        body: JSON.stringify({
          text: announcement,
          model_id: 'eleven_monolingual_v1',
          voice_settings: {
            stability: 0.5,
            similarity_boost: 0.5,
          },
        }),
      });

      if (!response.ok) throw new Error('TTS request failed');

      const audioBlob = await response.blob();
      const audioUrl = URL.createObjectURL(audioBlob);
      const audio = new Audio(audioUrl);
      await audio.play();
      
      audio.onended = () => URL.revokeObjectURL(audioUrl);
    } catch (err) {
      console.error('TTS Error:', err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { speak, isLoading };
};